import React, { useState } from "react";
import {
  SwipeableDrawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
  Divider,
  makeStyles,
  Box,
  Button,
  Avatar,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { AccountCircle, CameraAlt } from "@material-ui/icons";
import defaultImage from '../../../layout/icons/defaultPic.png';
import CloseIcon from '@material-ui/icons/Close';
import moment from "moment";
import EditWarehouseDetails from './EditWarehouseDetails';
import EditWarehouseStatus from './EditWarehouseStatus';
import DeleteWarehouse from './DeleteWarehouse';

const useStyles = makeStyles((theme) => ({
  list: {
    width: "40vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    // padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: "80vw",
    },
  },
  warehouseList: {
    width: "60%",
    padding: theme.spacing(2),
  },
  warehouseItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    borderBottom: "1px solid #ddd",
  },
  detailsContainer: {
    padding: theme.spacing(2),
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom:'8px',
  },
  avatar: {
    margin: '0px 8px',
  },
  editButton: {
    marginLeft: "auto",
  },
  imageUpload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "150px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    cursor: "pointer",
    position: "relative",
  },
  imageIcon: {
    position: "absolute",
      // top: "8px",
      bottom:'-14px',
    left: "8px",
    backgroundColor: '#e36e39',
    borderRadius: "50%",
      padding: "4px",
    '&:hover': {
        backgroundColor: '#e36e39',
    }
  },
  imagePreview: {
    width: "100%",
    height: "100%",
    // borderRadius: "8px",
    // objectFit: "cover",
    },
  teamMembers: {
      marginLeft:'10px',
        color: '#286ACF',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        textDecoration: 'underline',
  },
  textField: {
    '& input.MuiInputBase-input.MuiOutlinedInput-input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-multiline.MuiOutlinedInput-multiline':
      {
        paddingTop: '10px',
        paddingBottom: '10px',
      },
  },
  IconSty: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    // marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  deleteIconSty: {
    border: '1px solid #FF0000',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    color:'#FF0000',
    // marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FF0000',
      color: 'white',
      border: '1px solid #FFF',
    },
  }
}));


const ViewWarehouse = (props) => {
  const classes = useStyles();
  const { warehouseDetails, handleRefresh, closeView } = props;
//   const [drawerOpen, setDrawerOpen] = useState(false);
  const [editName, setEditName] = useState(false);
  const [warehouseName, setWarehouseName] = useState(warehouseDetails?.warehouseName ? warehouseDetails?.warehouseName:"");
  const [image, setImage] = useState(null);

//   const handleOpenDrawer = (warehouse) => {
//     setSelectedWarehouse(warehouse);
//     setWarehouseName(warehouse.name);
//     setDrawerOpen(true);
//   };

//   const handleCloseDrawer = () => {
//     setDrawerOpen(false);
//   };


 const [openDialogBox, setDialogBox] = useState({
        open: false,
        type: '',
        parameter: null,
      });
    
      const handleDialogBox = (type, value) => {
       
        setDialogBox({
          open: !openDialogBox.open,
          type: type,
          parameter: value,
        });
      };
    
      const handleCloseDialogBox = () => {
        setDialogBox({
          open: false,
          type: '',
          parameter: null,
        });
      };


  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };
  
  const getDaysFromToday = (inputDate) => {
    const today = moment().startOf('day'); // Start from today's date
    const givenDate = moment(inputDate, moment.ISO_8601, true).isValid() 
        ? moment(inputDate) 
        : moment(inputDate, 'MM/DD/YYYY'); // Adjust format if needed

    return today.diff(givenDate, 'days'); // Get the difference in days
};
    
  return (
    <div className={classes.list}>
    {/* Image Upload Section */}
    <Box className={classes.imageUpload}>
      {image ? (
        <img src={image} alt="Warehouse" className={classes.imagePreview} />
      ) : (
        <img src={defaultImage} alt="Warehouse" className={classes.imagePreview} />
      )}
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        id="image-upload"
        onChange={handleImageUpload}
      />
      <label htmlFor="image-upload">
        <IconButton 
                        disableRipple
                        disableFocusRipple
                      disableTouchRipple
                      className={classes.imageIcon} component="span" >
          <CameraAlt style={{color:'black'}} />
        </IconButton>
      </label>
    </Box>

    {/* Warehouse Name Section */}
          <Box className={classes.detailsContainer} >
              <div className={classes.header}>
                  
                  {!editName ? (
                      <Typography variant="h6">{warehouseName}
                          <Typography
                                        variant='caption' className={classes.teamMembers} onClick={() => setEditName(true)} >Rename</Typography>
                      </Typography>
        
          ) : (
              <div style={{display:'flex', alignItems:'center',justifyContent:'space-evenly', columnGap:'10px'}}>
<TextField
                variant="outlined"
                className={classes.textField}
                value={warehouseName}
                onChange={(e) => setWarehouseName(e.target.value)}
                onBlur={(e) => {
                  const { value } = e.target;
                  if (typeof value === "string" && value.trim() !== value) {
                    setWarehouseName(value.trim());
                  }
                }}
                // onBlur={() => setEditName(false)}
                autoFocus
              />
              <Button
                variant="contained"
                color="secondary"
                style={{ textTransform: "none" }}
              >
                Rename
              </Button>
              <CloseIcon
                fontSize="medium"
                style={{ cursor: "pointer" }}
                onClick={() => setEditName(false)}
              />
            </div>
          )}
          <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        style={{ padding: 0, borderRadius: 0 }}
                        //style={{ textTransform: 'none' }}
                          onClick={() => handleDialogBox('DeleteWarehouse', warehouseDetails)}
                          
                      >
                        <DeleteIcon className={classes.deleteIconSty} />
          </IconButton>
          
              </div>
              <div style={{display:'flex', alignItems:'center'}}>
      
      <Typography variant="body2" style={{display:'flex', alignItems:'center'}}>Created by <Avatar className={classes.avatar}>
      {warehouseDetails?.lastUpdatedBy ? String(warehouseDetails?.lastUpdatedBy).charAt(0) :'-'}
      </Avatar> {warehouseDetails?.lastUpdatedBy ? warehouseDetails?.lastUpdatedBy :'-NA- '} {getDaysFromToday(warehouseDetails?.lastUpdatedDate ? warehouseDetails.lastUpdatedDate : moment().startOf('day'))} days ago</Typography>
    </div>
    </Box>

    

    

    {/* Warehouse Details Section */}
      <Box className={classes.detailsContainer}>
      <Divider style={{ margin: "0px 0px 16px 0px" }} />
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <Typography variant="subtitle1" style={{fontWeight:'500'}}>Warehouse details</Typography>
          <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        style={{ padding: 0, borderRadius: 0 }}
                        onClick={() => handleDialogBox("EditWarehouse", warehouseDetails)}
                        
                      >
                        <EditIcon className={classes.IconSty} />
                      </IconButton>
                  
              </div>
              <Table>
                  <TableBody>
                      <TableRow>
                          <TableCell style={{border:'none', whiteSpace:'nowrap', width:'30%'}}>
                          Warehouse ID
                          </TableCell>
                          <TableCell style={{border:'none'}}>
                              {warehouseDetails?.warehouseCode ? warehouseDetails?.warehouseCode: ' - ' }
                          </TableCell>
                      </TableRow>
                      <TableRow>
                          <TableCell style={{border:'none', whiteSpace:'nowrap', width:'30%'}}>
                              Main address
                          </TableCell>
                          <TableCell style={{border:'none'}}>
                        {warehouseDetails?.warehouseMainAddress ? warehouseDetails?.warehouseMainAddress: ' - ' }            
              </TableCell>
                      </TableRow>
                      <TableRow>
                          <TableCell style={{border:'none', whiteSpace:'nowrap', width:'30%'}}>
                              Pickup address
                          </TableCell>
                          <TableCell style={{border:'none'}}>
                          {warehouseDetails?.pickupAddress ? warehouseDetails?.pickupAddress: ' - ' }  
                          </TableCell>
                      </TableRow>
                      <TableRow>
                          <TableCell style={{border:'none', whiteSpace:'nowrap', width:'30%'}}>
                              Delivery address
                          </TableCell>
                          <TableCell style={{border:'none'}}>
                          {warehouseDetails?.deliveryAddress ? warehouseDetails?.deliveryAddress: ' - ' }  
                          </TableCell>
                      </TableRow>
                  </TableBody>
              </Table>

      
    </Box>


    {/* Warehouse Status Section */}
      <Box className={classes.detailsContainer}>
      <Divider style={{ margin: "0px 0px 16px 0px" }} />
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <Typography variant="subtitle1" style={{fontWeight:'500'}}>Warehouse status</Typography>
          <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        style={{ padding: 0, borderRadius: 0 }}
                       // style={{ textTransform: 'none' }}
                          onClick={() => handleDialogBox('EditStatus', warehouseDetails)}
                      >
                        <EditIcon className={classes.IconSty} />
                      </IconButton>
                  
              </div>
              <Table>
                  <TableBody>
                      <TableRow>
                          <TableCell style={{border:'none', whiteSpace:'nowrap', width:'30%'}}>
                         Status
                          </TableCell>
                          <TableCell style={{border:'none'}}>
                              {warehouseDetails?.status ? warehouseDetails?.status: ' - ' }
                          </TableCell>
            </TableRow>
          </TableBody>
          </Table>
    </Box>
    {/* Swipeable Drawer for Dialogs */}

    {openDialogBox.open && (

<SwipeableDrawer anchor="right" open={openDialogBox.open} onClose={handleCloseDialogBox}>

  {openDialogBox.type === "EditWarehouse" && (

    <EditWarehouseDetails handleClose={handleCloseDialogBox} warehouseDetails={warehouseDetails} 
    handleRefresh = {handleRefresh}
    closeView ={closeView}
   
    />

  )}

  {openDialogBox.type === "EditStatus" && (

    <EditWarehouseStatus handleClose={handleCloseDialogBox} warehouseDetails={warehouseDetails} handleRefresh = {handleRefresh} closeView ={closeView}/>

  )}

  {openDialogBox.type === "DeleteWarehouse" && <DeleteWarehouse handleClose={handleCloseDialogBox} warehouseDetails={warehouseDetails} handleRefresh = {handleRefresh} closeView ={closeView}/>}

</SwipeableDrawer>

)}
    </div>
  )
}

export default ViewWarehouse